import { render, staticRenderFns } from "./DealMangement.vue?vue&type=template&id=189c7cef&scoped=true&"
import script from "./DealMangement.vue?vue&type=script&lang=js&"
export * from "./DealMangement.vue?vue&type=script&lang=js&"
import style0 from "./DealMangement.vue?vue&type=style&index=0&id=189c7cef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189c7cef",
  null
  
)

export default component.exports